import { motion } from "framer-motion";
import { forwardRef } from "react";
import { animations } from "../lib/animations";

type Props = {
  id?: string;
  icon: React.ReactNode;
  title?: string;
  subtitle: React.ReactNode;
  className?: string;
};

const Alert = forwardRef<HTMLDivElement, Props>(
  ({ id, icon, title, subtitle, className }: Props, ref) => {
    return (
      <motion.div
        key={id}
        ref={ref}
        initial={animations.slideUp.initial}
        animate={animations.slideUp.animate}
        exit={animations.slideUp.exit}
        transition={animations.spring.medium}
        style={{
          borderWidth: "var(--alert-border-width)",
          borderColor: "var(--color-alert-border)",
        }}
        className={`bg-[--color-alert-background] px-2 py-3 rounded-lg flex gap-2 ${className || ""}`}
      >
        <div className={`${title ? "mt-0.5" : ""} text-[--color-alert-accent]`}>
          {icon}
        </div>
        <div>
          {title ? (
            <div className="text-sm font-medium text-[--color-text-primary]">
              {title}
            </div>
          ) : null}
          <div
            className={`text-xs ${title ? "text-[--color-text-secondary] mt-1" : "text-[--color-text-primary]"}`}
          >
            {subtitle}
          </div>
        </div>
      </motion.div>
    );
  },
);

export default Alert;
